import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { KbErrorMessageComponent } from "./kbBrakeApllicationForms-module/kbAppErrorDiv.component";
import { I18nModule } from "@spartacus/core";

@NgModule({
    declarations: [
        KbErrorMessageComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        I18nModule
    ],
    exports: [KbErrorMessageComponent]

})
export class kbRequiredErrorDivModule { }